import { render, staticRenderFns } from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=template&id=72472bce&scoped=true"
import script from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=script&lang=js"
export * from "./BulkCopyAndResizeTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72472bce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72472bce')) {
      api.createRecord('72472bce', component.options)
    } else {
      api.reload('72472bce', component.options)
    }
    module.hot.accept("./BulkCopyAndResizeTemplatesModal.vue?vue&type=template&id=72472bce&scoped=true", function () {
      api.rerender('72472bce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/BulkCopyAndResizeTemplatesModal.vue"
export default component.exports